/**
 * @import {AttributeAdapter} from "@html-eslint/core"
 * @import {JSXSpreadAttribute} from "../../types"
 */

/** @implements {AttributeAdapter} */
class JSXSpreadAttributeAdapter {
  /** @param {JSXSpreadAttribute} node */
  constructor(node) {
    this.node = node;
  }

  getKey() {
    return null;
  }

  getValue() {
    return null;
  }
}

module.exports = {
  JSXSpreadAttributeAdapter,
};
